import React, { useState } from "react";
import { Collapse, useTheme } from "@mui/material";
import { Bot, ChevronDown, ChevronUp } from "lucide-react";
import { useTranslation } from "react-i18next";
import {
  CapabilitiesContainer,
  CapabilitiesContent,
  CapabilitiesHeader,
  CapabilitiesIconBox,
  CapabilitiesList,
  CapabilitiesListItem,
  CapabilitiesText,
  CapabilitiesToggle,
} from "@components/ChatAgent/components/ChatAgentCapabilities/style";

const CAPABILITIES_ITEMS = [1, 2, 3, 4, 5, 6];

const ChatAgentCapabilities: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation("agent_chat");
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <CapabilitiesContainer
      id="agent-capabilities"
      data-testid="agent-capabilities"
    >
      <CapabilitiesHeader>
        <CapabilitiesIconBox>
          <Bot aria-hidden={true} color={theme.palette.textInput} size={24} />
        </CapabilitiesIconBox>
        <CapabilitiesToggle
          type="button"
          id="agent-capabilities-toggle"
          aria-expanded={isExpanded}
          aria-controls="agent-capabilities-content"
          onClick={() => setIsExpanded((prev) => !prev)}
        >
          {isExpanded ? t("capabilities_hide") : t("capabilities_show")}
          {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
        </CapabilitiesToggle>
      </CapabilitiesHeader>
      <Collapse in={isExpanded} timeout="auto" unmountOnExit>
        <CapabilitiesContent id="agent-capabilities-content">
          <CapabilitiesText>{t("capabilities_intro")}</CapabilitiesText>
          <CapabilitiesList>
            {CAPABILITIES_ITEMS.map((item) => (
              <CapabilitiesListItem key={`capabilities_item_${item}`}>
                {t(`capabilities_item_${item}`)}
              </CapabilitiesListItem>
            ))}
          </CapabilitiesList>
        </CapabilitiesContent>
      </Collapse>
    </CapabilitiesContainer>
  );
};

export default ChatAgentCapabilities;
